<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">订单详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="page_top list_top">
      <div class="icon">
        <img src="/static/newprojecticon/yizhifu.png" class="iconimg" />
        <span v-if="list.status_str" class="icon_text">{{list.status_str}}</span>
      </div>
    </div>
    <div class="order_preview">
      <div class="order_preview_bd">
        <div class="order_preview_item">
          <div class="order_preview_label">订单名称</div>
          <div class="order_preview_value">{{list.product_name}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单编号</div>
          <div class="order_preview_value">{{list.order && list.order.order_no}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单时间</div>
          <div class="order_preview_value">{{list.created_at}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">车辆信息</div>
          <div class="order_preview_value">{{list.car_no}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">联系人姓名</div>
          <div class="order_preview_value">{{list.username}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">联系人电话</div>
          <div class="order_preview_value">{{list.mobile}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">详细地址</div>
          <div class="order_preview_value">{{list.address}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">检测站</div>
          <div class="order_preview_value">{{list.store && list.store.name}}</div>
        </div>
        <div class="order_preview_item" v-if="list.salesman">
          <div class="order_preview_label">接单人姓名</div>
          <div class="order_preview_value">{{list.salesman.name}}</div>
        </div>
        <div class="order_preview_item" v-if="list.salesman">
          <div class="order_preview_label">接单人电话</div>
          <div class="order_preview_value"><a class="contLinephone" :href="'tel:' + list.salesman.mobile">{{list.salesman.mobile}}</a></div>
        </div>
        <!-- <div class="order_preview_item">
          <div class="order_preview_label">预约时间</div>
          <div class="order_preview_value">{{list.store.name}}</div>
        </div> -->
        <!--    <div class="order_preview_item">
          <div class="order_preview_label">商品总价</div>
          <div class="order_preview_value">￥{{list.order.product_price}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单金额</div>
          <div class="order_preview_value">￥{{list.order.amount}}</div>
        </div> -->
        <div class="order_preview_item">
          <div class="order_preview_label">实付金额</div>
          <div class="order_preview_value">￥{{list.order && list.order.paid_amount}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">支付方式</div>
          <div class="order_preview_value">{{list.order && list.order.pay_type_str}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">支付状态</div>
          <div class="order_preview_value">{{list.order && list.order.pay_status_str}}</div>
        </div>
        <div class="order_preview_item">
          <div class="order_preview_label">订单状态</div>
          <div class="order_preview_value">{{list.status_str}}</div>
        </div>
        <div class="order_preview_item" v-if="list.salesman">
          <div class="order_preview_label">接单人信息</div>
          <div class="order_preview_showpopup" @click="showPopup">查看信息</div>
        </div>
      </div>
      <div class="order_preview_ft">
        <div class="order_preview_btn order_preview_btn_primary" @click="returnIndex">
          <a>返回首页</a>
        </div>
      </div>
    </div>
    <!-- 接单人信息弹框 开始 -->
    <van-popup v-model="showMesg" :style="{ height: '30%' ,width:'70%'}" round closeable="true">
      <div class="meetingmesgbox">
        <div class="popupmesg_imgbox">
          <img :src="list.salesman.image ? list.salesman.image : '/static/morenimg.png'" class="popupmesg_img" />
        </div>
        <div class="popupmesg_box">
          <div class="popupmesg_name">接单人姓名</div>
          <div class="popupmesg_value">{{list.salesman.name}}</div>
        </div>
        <div class="popupmesg_box">
          <div class="popupmesg_name">接单人电话</div>
          <div class="popupmesg_value"><a class="contLinephone" :href="'tel:' + list.salesman.mobile">{{list.salesman.mobile}}</a></div>
        </div>
      </div>

    </van-popup>
    <!-- 接单人信息弹框 结束 -->
    <!-- <div class="orderDenone"></div>
    <div class="fanhuiindex" @click="fanhui">返回首页</div> -->
  </div>
</template>
<script>
  import httper from '../../api/http';

  export default {
    data() {
      return {
        id: '', // 上一页面获取参数,默认为空
        list: [], //获取详情列表参数,默认为空
        timechao: false, //判断对比当前时间是否大于订单时间，默认为false
        currentTime: '', // 倒计时,默认为空
        navIndex: 0 ,//上一页面获取指针参数
        showMesg:false,//是否显示弹出层
      }
    },
    created() {
      let that = this
      //上一页面传过来的参数
      if (that.$route.query.navIndex) {
        that.navIndex = that.$route.query.navIndex
      }
      if (that.$route.query.id) {
        that.id = that.$route.query.id
      } else {
        if (!that.id) {
          this.$toast({
            message: '参数错误',
          })
          setTimeout(function() {
            history.back()
          }, 1000)
          return
        }
      }

      this.request('getDetail', {
        id: that.id
      })
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      returnIndex() {
        this.$router.push({
          path: "/"
        })
      },
      // 弹出层
      showPopup() {
        this.showMesg = true;
      },
      toSecondPayDetail() {
        this.$router.push({
          path: "/SecondPayment",
          query: {
            order_no: this.list.order.order_no
          }
        })
      },
      fanhui() {
        // this.$router.go(-1);
        this.$router.push({
          path: "/orderList",
          query: {
            order_status: this.navIndex
          }
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取订单详情
          case 'getDetail':
            httper.get('/annual-review/get-detail', requestData, res => {
              if (res.code === 0) {
                console.log("res", res)
                // 初始化数据
                this.list = res.data
              } else {
                this.$toast({
                  message: res.message || '系统错误',
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>
<style scoped>
  .list_top {
    background-image: url(../../../static/newprojecticon/zhifubg.png);
    background-size: contain;
    height: 153px;
  }

  .icon {
    width: 100%;
    height: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .iconimg {
    width: 40px;
    height: 40px;
    margin-bottom: 15px;
  }

  .icon_text {
    font-size: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .order_preview {
    position: relative;
    background-color: #fff;
    position: absolute;
    top: 180px;
    width: 90%;
    margin: 0 20px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 0px 0px 8px 8px;
  }

  .order_preview:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.1);
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .order_preview_bd {
    padding: 16px;
    font-size: 0.9em;
    text-align: right;
    color: rgba(0, 0, 0, 0.5);
    line-height: 2;
  }



  .order_preview_item {
    overflow: hidden;
  }

  .order_preview_item1 {
    overflow: hidden;
    margin-bottom: 15px;
  }

  .order_preview_label {
    float: left;
    margin-right: 1em;
    min-width: 4em;
    color: rgba(0, 0, 0, 0.5);
    text-align: justify;
    -moz-text-align-last: justify;
    text-align-last: justify;
  }

  .order_preview_value {
    display: block;
    overflow: hidden;
    word-break: normal;
    word-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
  }

  .order_preview_ft {
    position: relative;
    line-height: 50px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .order_preview:after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 1px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.1);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .order_preview_btn_primary {}

  .order_preview_btn {
    position: relative;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .orderDenone {
    width: 100%;
    height: 240px;
  }

  .fanhuiindex {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ea6156;
  }

  .order_product_address {
    display: flex;
    border-bottom: 1px solid #E5E5E5;
    align-items: center;
    text-align: start;
  }

  .order_product_addressicon {
    /* width: 10%;
    margin-right: 10px;
    height: 36px; */
    width: 6%;
    height: 20px;
    margin-right: 10px;

  }

  .order_product_addressmesg {
    width: 90%;
  }

  .order_product_addressname {
    font-size: 15px;
    display: flex;
    /* margin-bottom: 10px; */
    color: #000000;
  }

  .order_product_addressphone {
    margin-left: 10px;
  }

  .order_product_addressdetail {
    font-size: 12px;
    color: #666666;
    margin-bottom: 5px;
  }

  .order_product_detail {
    display: flex;
    align-items: center;
    margin: 15px 0;
  }

  .order_product_detailimg {
    width: 17%;
    height: 58px;
    margin-right: 10px;
    border-radius: 8px;
  }

  .order_product_detailthum {
    width: 100%;
    height: 100%;
    border-radius: 8px;

  }

  .order_product_detailmesg {
    width: 80%;
    text-align: start;
  }

  .order_product_detailproname {
    font-size: 12px;
    margin-bottom: 10px;
    color: #000000;
  }

  .order_product_detailbottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  .order_product_detailguige {
    color: #666666;
  }

  .order_product_detailprice {
    color: #ea6156;
  }

  .order_preview_value11 {
    color: #FD8C00;
    font-size: 12px;
  }

  .order_preview_showpopup {
    color: #FD8C00;
    font-size: 12px;
  }

  .meetingmesgbox {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .popupmesg_imgbox {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .popupmesg_img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
  }

  .popupmesg_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .popupmesg_name {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
  }

  .popupmesg_value {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.9);
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/annualReviewDetail.vue